export const IntegrationTypesActionTypes = {
    API_RESPONSE_SUCCESS: '@@integration-types/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@integration-types/API_RESPONSE_ERROR',
    GET_ALL_INTEGRATION_TYPES: '@@integration-types/GET_ALL_INTEGRATION_TYPES',
    RESET_STATE: '@@integration-types/RESET_STATE',
    RESET_ALL_ERRORS: '@@integration-types/RESET_ALL_ERRORS',
};
